/**
 * The structure of the Hero object
 */
export class Image {
  height = 0;
  width = 0;
  url = '';
}
